import React, { useEffect, useState } from 'react';
import { RiCloseLine, RiSearch2Fill, RiUploadCloud2Fill } from 'react-icons/ri'
import { MdDeleteForever } from 'react-icons/md'
import { ImCancelCircle, ImDownload } from 'react-icons/im'
import { isNumberWithoutDecimal, validateFileFormat } from '../../../service/utilService';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { getClaimedAvcDropDownData, getClaimedAvcFareAmount, getDisputeDetails, submitDisputeDetails, getPlazaTAT,getAllViolationReason } from '../../../common/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa';

const reasonCodeList = [
  { name: '2001-Toll fare calculation error', value: '2001-Toll fare calculation error' },
  { name: '2002-Duplicate transaction done at toll plaza', value: '2002-Duplicate transaction done at toll plaza' },
  { name: '2003-Tag holder was charged for unsuccessfully transaction', value: '2003-Tag holder was charged for unsuccessfully transaction' },
  { name: '2005-Paid by other means', value: '2005-Paid by other means' },
  { name: '2006-Vehicle is in exempted list', value: '2006-Vehicle is in exempted list' },
  { name: '2007-Other specify', value: '2007-Other specify' }
]

export default function RaiseDisputeScreen(props) {

  const { setShowRaisedVioScreen, data, impactedTransaction } = props;
  const { plazaTxnId, cchTxnId, txnDate, processedTime, plazaName, laneId, vrn, tagId, mapperClass, avcClassAmt, settleAmt, rrn, plazaId, readerReadTime, avcClass, journeyId, bankProcessingDate, entryTollPlazaId, entryPlazaName, priceMode, srtlFareFlag, srtlFlagDesc, srtlAttribute, gvw} = data

  const [docName, setDocName] = useState([]);
  const [docArr, setDocArr] = useState([]);
  const [showDoc, setShowDoc] = useState(false);
  const [refundAmount, setRefundAmount] = useState("");
  const [claimedAvc, setClaimedAvc] = useState("");
  const [remarks, setRemarks] = useState("");
  const [mineralMajorFlag, setMineralMajorFlag] = useState("No");
  const [mineralMajorFlagList, setMineralMajorFlagList] = useState([
    {name:'Yes', value:'Yes'},
    {name:'No', value:'No'}
  ]);
  const [mineralMajorFlagListDisabled, setMineralMajorFlagListDisabled] = useState(true);
  const [claimedavclist, setClaimedAvcList] = useState([]);
  const [reasonCode, setReasonCode] = useState("");
  const [isDisputeAmountLoading, setIsDisputeAmountLoading] = useState(false);
  const [disputeAmt, setDisputeAmt] = useState('--');
  const [concessVcClass, setConcessVcClass] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [plazaTAT, setPlazaTAT] = useState(0);
  const [selectedGVWAvc,setSelectedGVWAvc] = useState("");
  const [acvAmt, setacvAmt] = useState(0);
  const [reasonList, setReasonList] = useState([]);
  const [violationReason, setViolationReason] = useState("");

  const isRaiseRefund = impactedTransaction === 'raiseRefund';
  const isEligibleForDA = impactedTransaction === 'eligibleForDA';
  const disputeType = isRaiseRefund ? 'Raise Refund' : 'Raise New Violation';
  const titleClass = isRaiseRefund ? 'raiseRefundTitle' : 'raiseNewVioTitle';
  const amountLabel = isRaiseRefund ? 'Refund Amount' : 'Dispute Amount';
  const tatDays = isRaiseRefund ? 25 : 3;

  var tatRemainingDays = tatDays - moment().diff(moment(readerReadTime), "days");

  useEffect(() => {
    setConcessVcClass(data.vcclass);
  }, [data])
  console.log("Value of GVW",gvw)
  const [fields, setFields] = useState({
    reasonCode: { valid: true, msg: "Please select Reason Code!" },
    claimedAVC: { valid: true, msg: "Please select Claimed AVC!" },
    violationReason: { valid: true, msg: "Please select Violation Reason!" },
    remarks: { valid: true, msg: "Please enter remark!" },
    refundAmount: { valid: true, msg: "Please enter Amount!" },
    images: { valid: true, msg: "Please select at least 2 images!" },
    mineralMajorFlag: { valid: true, msg: "Please select Mineral Major Flag!" },
  })
  useEffect(() => {
    fetchReasonDropdown(plazaId);
  }, []);
  const validateFields = (key, valid) => {
    setFields(old => ({ ...old, [key]: { ...old[key], valid } }))
  }

  const getTATData = () => {

    getPlazaTAT().then(res => {
      //console.log("data " + res.data);
      if (res) {
        setPlazaTAT(parseInt(res.data));
        
      }
    }).catch(err => {
      console.log("Get Plaza TAT API Error " + err);
    })
  }
    const fetchReasonDropdown = async (plazaId) => {
        try {
          const response = await getAllViolationReason(plazaId);
          const reasonList1 = response.data.map(e => (
                  { name: `${e.reasonCd} : ${e.reasonName}`, value: e.reasonCd }
                ))
          setReasonList(reasonList1);
        } catch (error) {
          console.error("Error fetching Reason list:", error);
        }
      };
//       const reasonOptions = reasonList.map((reason) => ({
//           label: `${reason.reasonCd} : ${reason.reasonName}`,
//           value: reason.reasonName,
//         }));
const handleReasonChange = (value) => {
  setViolationReason(value);
  validateFields('violationReason', !!value);
};
  useEffect(() => {
    getTATData();
    const jsonData = {
      plazaId: Array.isArray(plazaId) ? plazaId.join(",") : plazaId,
      entryTollPlazaId: entryTollPlazaId||""
    }

    getClaimedAvcDropDownData(jsonData).then((res) => {
      res.data.sort((a, b) => {
        return +a.concessValue > +b.concessValue ? 1 : +a.concessValue < +b.concessValue ? -1 : 0;
      })
      const avcList = res.data.map(e => (
        { name: getClaimedVcName(e), value: e.concessDesc + "@@" + e.concessValue }
      ))
      setClaimedAvcList(avcList);
      const match = avcList.find(
        opt => String(opt.value.split('@@')[1]) === String(gvw)
      );
      if (match) 
      { 
        setSelectedGVWAvc(match.value);
        getDisputeAmt(match.value);
      }
      
      console.log("gvw:", gvw);
      console.log("default match:", match);

    }).catch((err) => {
      setClaimedAvcList([]);
    });
  }, [])


  useEffect(()=>{
    if (!isRaiseRefund) {
      const plazaTATDays = plazaTAT / 24;
      tatRemainingDays = plazaTATDays - moment().diff(moment(readerReadTime), "days");
    }
  },[plazaTAT])

  useEffect(()=>{
    if(claimedAvc && mineralMajorFlag){
      const headerJson = {
        entryTollPlazaId: entryTollPlazaId|| "",
        settlementAmt: settleAmt,
        vcClass: concessVcClass,
        concessVcClass: claimedAvc.split("@@")[1],
        readerReadTime: readerReadTime,
        mineralMajorFlag:mineralMajorFlag.charAt(0),
        srtlFareFlag:srtlFareFlag
      }
      const bodyJson = {
        plazaId: Array.isArray(plazaId) ? plazaId.join(",") : plazaId,
      }
      calculateClaimedAVCDareAmountFun(headerJson, bodyJson);
    }
  },[claimedAvc,mineralMajorFlag])


  const getClaimedVcName = (val) => {
    return `${val.concessValue} / ${val.concessDesc?.slice(0, 20)} ${(val.concessDesc?.length > 20 ? '...' : '')}`
  }

  const setRemarksVal = (val) => {
    setRemarks(val);
    if (val)
      validateFields('remarks', true);
    else
      validateFields('remarks', false);
  }

  const validateRefundAmount = (val) => {

    if (val.includes(".") && !val.split(".")[1]) {
      setRefundAmount(val + "0");
    }
  }

  const setRefundAmountVal = (val) => {
    if (val)
      validateFields('refundAmount', true);
    else
      validateFields('refundAmount', false);
    const reg = /^[0-9]+(\.[0-9]{0,2})?$/;
    if (val && !reg.test(val)) return;
    setRefundAmount(val);
  }

  const showDocList = () => {
    setShowDoc(!showDoc);
  };

  const fileUpload = (e) => {
    const files = [...e.currentTarget.files];
    if (docArr.length + files.length >= 2) {
      validateFields('images', true);
    } else {
      validateFields('images', false);
    }
    let { names, docs } = validateFileFormat(files);
    let newDocArr = [...docArr, ...docs];
    let newDocName = [...docName, ...names];
    setDocName(newDocName);
    setDocArr(newDocArr);
  };

  const deleteItem = (index) => {
    const docs = [...docName];
    const docsFile = [...docArr];
    docs.splice(index, 1);
    docsFile.splice(index, 1);
    setDocName(docs);
    setDocArr(docsFile);
    if (docsFile.length < 2) {
      validateFields('images', false);
    }
  };

  const setReasonCodeValue = (val) => {
    setReasonCode(val);
    let remarks = val === '2007-Other specify' ? "" : val
    setRemarks(remarks);
    validateFields('reasonCode', val ? true : false);
    validateFields('remarks', val ? true : false);
  }

  const setMineralMajorFlagValueFun=(val)=>{
    setMineralMajorFlag(val);
    setIsDisputeAmountLoading(true);
  }

  const submitRaisedDispute = () => {
    //toast.dismiss();
    if (!reasonCode && isRaiseRefund) {
      validateFields('reasonCode', false);
      return;
    }

    if (!claimedAvc && !isRaiseRefund) {
      validateFields('claimedAVC', false);
      return;
    }

    if (!violationReason &&  !isRaiseRefund) {
      validateFields('violationReason', false);
      return;
    }

    if (isRaiseRefund && +refundAmount > settleAmt) {
      toast.warning("Refund amount should not be greater than Settle Amount");
      setRefundAmount("")
      validateFields('refundAmount', false);
      return
    }


    if (!isRaiseRefund && disputeAmt < 1) {
      toast.warn("Raised Dispute is less than 1. Can not Raised dispute for this Violation!");
      return;
    }
    if (isRaiseRefund && refundAmount < 1) {
      toast.warn("Refund amount is less than 1. Can not Raised dispute for this Violation!");
      return;
    }

    if (!remarks) {
      validateFields('remarks', false);
      return;
    }

    if (docName.length < 1 && !isRaiseRefund) {
      validateFields('images', false);
      return;
    }
    if (docName.length < 2 && !isRaiseRefund) {
      validateFields('images', false);
      return;
    }
    let formData = new FormData();
    docArr.forEach((doc) => {
      formData.append("file", doc)
    })
    const raisedRefund = {
      refundAmount,
      reasonCode,
    }
    const headerJson = {
      claimedAvc: claimedAvc?.split('@@')[0] || '',
      cvc: claimedAvc?.split('@@')[1] || '',
      disputeAmount: disputeAmt,
      avcAmount: acvAmt,
      remarks,
      txnId: rrn,
      mineralMajorFlag:(srtlFareFlag=='Y'?mineralMajorFlag:null),
      mineralMajorFlagFare:mineralMajorFlag.charAt(0),
      srtlFlag:(srtlFareFlag=='Y'?srtlAttribute:null),
      srtlFareFlag:srtlFareFlag,
      entryTollPlazaId: entryTollPlazaId|| "",
      settlementAmt: settleAmt,
      vcClass: concessVcClass,
      readerReadTime: readerReadTime,
      plazaId: plazaId,
      violationReasonCd:violationReason,
      impactedTransaction,
      ...(isRaiseRefund ? raisedRefund : {})
    }
    //console.log(headerJson);
    setIsSubmitLoading(true)
    submitDisputeDetails(headerJson,formData, impactedTransaction).then(res => {
      if (isRaiseRefund)
        toast.success('Successfully Raised Refund!');
      else
        toast.success('Successfully Raised New Violation!');
      setShowRaisedVioScreen(false);
      setIsSubmitLoading(false)
    }).catch(_ => {
      setIsSubmitLoading(false);
      toast.warn("Something goes wrong!");
    });
  }

  const getDisputeAmt = (val) => {
    setClaimedAvc(val);
    const vechicleClass=val.split('@@')[1];
    if(vechicleClass=='6' || vechicleClass=='7' || vechicleClass=='8' || vechicleClass=='12' || vechicleClass=='14'|| vechicleClass=='17'){
      setMineralMajorFlagListDisabled(false);
    }else{
      setMineralMajorFlagListDisabled(true);
      setMineralMajorFlag("No");
    }
    if (val) {
      validateFields('claimedAVC', true);
    }
    setIsDisputeAmountLoading(true)
  }

  function calculateClaimedAVCDareAmountFun(headerJson, bodyJson){
    getClaimedAvcFareAmount(headerJson, bodyJson).then(res => {
      setDisputeAmt(res.data.fareAmount);
      setacvAmt(res.data.avcAmount)
      setIsDisputeAmountLoading(false);
    }).catch(err => {
      setDisputeAmt(0);
      setIsDisputeAmountLoading(false);
    })
  }

  const clearFields = () => {
    setReasonCode("");
    setRefundAmount("");
    setClaimedAvc("");
    setRemarks("");
    setDocName([]);
    setDisputeAmt("--");
    setDocArr([]);
  }

  const setRefundAmt = (val) => {
    setRefundAmount(val);
  }

  return (
    <div className='raised-vio-screen'>
      <div className='raised-vio-screen-header'>
        <div className='raised-dispute'>Raise Dispute</div>
        <div className='closebtn'><RiCloseLine onClick={() => { setShowRaisedVioScreen(false) }} /></div>
      </div>
      <div className='transaction-info'>
        <div><label htmlFor="">Plaza Transaction ID</label><span>{plazaTxnId}</span></div>
        <div><label htmlFor="">CCH Transaction ID</label><span>{cchTxnId}</span></div>
        <div><label htmlFor="">Reader Read Time</label><span>{txnDate && moment(txnDate).format("DD-MM-YYYY HH:mm:ss")}</span></div>
        <div><label htmlFor="">Bank Processing Time</label><span>{processedTime && moment(processedTime).format("DD-MM-YYYY HH:mm:ss")}</span></div>
        {priceMode && priceMode ==='D'?
        <React.Fragment>
        <div><label htmlFor="">Entry Plaza Name</label><span>{entryPlazaName} ({entryTollPlazaId})</span></div><div><label htmlFor="">Exit Plaza Name</label><span>{plazaName} ({plazaId})</span></div>
        </React.Fragment>
        :<div><label htmlFor="">Plaza Name</label><span>{plazaName} ({plazaId})</span></div>}
        <div><label htmlFor="">Lane ID</label><span>{laneId}</span></div>
        <div><label htmlFor="">VRN</label><span>{vrn}</span></div>
        <div><label htmlFor="">Tag ID</label><span>{tagId}</span></div>
        <div><label htmlFor="">Mapper Class</label><span>{mapperClass}</span></div>
        <div><label htmlFor="">AVC Class</label><span>{avcClass}</span></div>
        <div><label htmlFor="">Journey Type</label><span>{journeyId}</span></div>
        <div><label htmlFor="">AVC Class Amount</label><span>{avcClassAmt}</span></div>
        <div><label htmlFor="">Settle Amount</label><span>{settleAmt}</span></div>
      </div>

      <div className={'dispute-section ' + impactedTransaction}>
        <div><label htmlFor="">Dispute Type</label><span className={"blockTitle " + titleClass} >{disputeType}</span></div>
        {isRaiseRefund && <>
          {/* <div className='refund-amount'>
              <label htmlFor="">Refund Amount <sup>*</sup></label>
              <input onChange={()=>setRefundAmt('full')} checked={refundAmount === 'full'}  type="radio" name="refund-amount" id="full"/> <label className='radio-label' htmlFor="full">Full</label>
              &nbsp; &nbsp; &nbsp; &nbsp;
              <input onChange={()=>setRefundAmt('partial')} checked={refundAmount === 'partial'} type="radio" name="refund-amount" id="partial"/> <label className='radio-label' htmlFor="partial">Partial</label>
          </div> */}
          <div className='flex claimed-avc-dropdown'><label htmlFor="">Reason Code <sup>*</sup></label>
            <div className={!fields.reasonCode.valid && "error-field"}>
              <SelectSearch
                options={reasonCodeList}
                search
                filterOptions={fuzzySearch}
                placeholder="Select Reason code"
                value={reasonCode}
                onChange={setReasonCodeValue}
              />
              {!fields.reasonCode.valid && <p className='invalid-field-message'>{fields.reasonCode.msg}</p>}
            </div>
          </div>
        </>
        }
        {!isRaiseRefund && !isEligibleForDA && <>
          <div className='flex claimed-avc-dropdown'><label htmlFor="">Claimed AVC <sup>*</sup></label>
            <div className={!fields.claimedAVC.valid && "error-field"}>
              <SelectSearch
                options={claimedavclist}
                search
                filterOptions={fuzzySearch}
                placeholder="Claimed AVC"
                value={claimedAvc}
                onChange={getDisputeAmt}
              />
              {!fields.claimedAVC.valid && <p className='invalid-field-message'>{fields.claimedAVC.msg}</p>}
            </div>
          </div>
        </>}
        {isEligibleForDA && <>
          <div className='flex claimed-avc-dropdown'><label htmlFor="">Claimed GVW-AVC <sup>*</sup></label>
            <div className={!fields.claimedAVC.valid && "error-field"}>
              <SelectSearch
                options={claimedavclist}
                search
                filterOptions={fuzzySearch}
                placeholder="Claimed GVW-AVC"
                value={selectedGVWAvc}
                onChange={getDisputeAmt}
              />
              {!fields.claimedAVC.valid && <p className='invalid-field-message'>{fields.claimedAVC.msg}</p>}
            </div>
          </div>
        </>}
        {!isRaiseRefund && <>
          <div className='flex claimed-avc-dropdown'><label htmlFor="">Violation Reason <sup>*</sup></label>
            <div className={!fields.violationReason.valid && "error-field"}>
              <SelectSearch
                options={reasonList}
                search
                filterOptions={fuzzySearch}
                placeholder="Violation Reason"
                value={violationReason}
                onChange={handleReasonChange}
              />
              {!fields.violationReason.valid && <p className='invalid-field-message'>{fields.violationReason.msg}</p>}
            </div>
          </div>
        </>}
        { srtlFareFlag  && srtlFareFlag=='Y' && <>
            <div><label htmlFor="">SRTL Flag </label><span>{srtlFlagDesc}</span></div>
            <div className='flex claimed-avc-dropdown'><label htmlFor="">Mineral Major Flag <sup>*</sup></label>
              <div className={!fields.mineralMajorFlag.valid && "error-field"}>
                <SelectSearch
                  options={mineralMajorFlagList}
                  search
                  filterOptions={fuzzySearch}
                  placeholder="Mineral Major Flag"
                  value={mineralMajorFlag}
                  onChange={setMineralMajorFlagValueFun}
                  disabled={mineralMajorFlagListDisabled}
                />
                {!fields.mineralMajorFlag.valid && <p className='invalid-field-message'>{fields.mineralMajorFlag.msg}</p>}
              </div>
            </div>
            
          </>}

        <div className='flex'><label htmlFor="">{amountLabel} (&#8377;)<sup>*</sup></label>
          {isRaiseRefund
            ? <div>
              <input type="text" id="refundAmount" name="refundAmount" value={refundAmount}
                onChange={(e) => setRefundAmountVal(e.target.value)}
                onBlur={() => validateRefundAmount(refundAmount)}
                className={!fields.refundAmount.valid && "error-input-field"} />
              {!fields.refundAmount.valid && <p className='invalid-field-message'>{fields.refundAmount.msg}</p>}
            </div>
            : <span>{isDisputeAmountLoading ? <FaSpinner icon="spinner" spin className="spinner" /> : disputeAmt}</span>
          }
        </div>
          
        <div><label htmlFor="">TAT Remaining (Days)</label><span>{tatRemainingDays}</span></div>
        
        <div className='flex' placeholder="Enter the Remarks"><label htmlFor="">Remarks<sup>*</sup></label>
          <div>
            <input type="text" id="remarks" name="remarks" autoComplete='off' value={remarks} onChange={(e) => setRemarksVal(e.target.value)} className={!fields.remarks.valid && "error-input-field"} />
            {!fields.remarks.valid && <p className='invalid-field-message'>{fields.remarks.msg}</p>}
          </div>
        </div>
        {!isRaiseRefund && <>
          <div className='flex'>
            <label htmlFor="">Upload image<sup>*</sup></label>
            <div className={(!fields.images.valid ? "error-field" : "") + " upload-doc-wrapper"} >
              <div className="raise-dispute-upload-btn" >
                <label htmlFor="myfile" className="btn inside-upload-btn"> Upload Documents <RiUploadCloud2Fill /> </label>
                <input type="file" id="myfile" name="docName" multiple style={{ display: "none" }} onChange={(e) => fileUpload(e)} />
              </div>
              {(showDoc && docName.length > 0) && (
                <div className='upload-docs-popup'>
                  <div className="upload-docs-row upload-docs-heading" > Uploads Files <ImCancelCircle onClick={showDocList} /> </div>
                  {
                    docName.map((docName, index) => {
                      return (
                        <div className="upload-docs-row" key={index}> {docName} <MdDeleteForever onClick={() => deleteItem(index)} /> </div>
                      );
                    })
                  }
                </div>
              )}
              {!fields.images.valid && <p className='invalid-field-message'>{fields.images.msg}</p>}
              <div className="doc-format"> {docName?.length > 0 && <p onClick={showDocList}> view details </p>} </div>
            </div>
          </div>
        </>}
      </div>

      <div className='dispute-action-buttons'>
        <button className='dispute-button dispute-cancel' onClick={() => { setShowRaisedVioScreen(false) }}>Cancel</button>
        <button className='dispute-button dispute-clear' onClick={clearFields}>Clear</button>
        <button className='dispute-button dispute-raise' onClick={submitRaisedDispute}>Raise Dispute  {isSubmitLoading && <FaSpinner icon="spinner" spin className="spinner" />}</button>
      </div>
    </div>
  )
}
